export default __webpack_public_path__ + "static/media/chachi.dd4aedc7.jpeg";